// extracted by mini-css-extract-plugin
export default {"contactsBlock":"contactList_contactsBlock__TQOK4","contactHasUnread":"contactList_contactHasUnread__8DhwT","contactActive":"contactList_contactActive__U1B-N"};